var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "plectrum",
  "use": "plectrum-usage",
  "viewBox": "0 0 6 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 6\" id=\"plectrum\"><path fill=\"#000\" fill-rule=\"evenodd\" d=\"M5.969 2.773a1.4 1.4 0 0 0-.17-.323 5.8 5.8 0 0 0-.881-.953A6.136 6.136 0 0 0 2.22.138 5 5 0 0 0 1.26 0h-.086a.64.64 0 0 0-.542.295C.602.339.572.384.55.432.482.594.411.755.353.92a6 6 0 0 0-.347 1.715 6.1 6.1 0 0 0 .311 2.21c.088.262.18.52.315.762.104.187.24.342.464.378q.165.026.332.008a6 6 0 0 0 1.092-.22 6.13 6.13 0 0 0 3.11-2.1c.117-.147.233-.296.31-.47a.55.55 0 0 0 .029-.43\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol